import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faSearch } from '@fortawesome/free-solid-svg-icons';

const EmptyArticlesState = ({ theme }) => {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3rem 1rem',
      textAlign: 'center',
      minHeight: '400px',
    },
    icon: {
      fontSize: '4rem',
      color: theme?.text?.tertiary,
      marginBottom: '1.5rem',
    },
    title: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: theme?.text?.primary,
      marginBottom: '0.5rem',
    },
    description: {
      fontSize: '1rem',
      color: theme?.text?.secondary,
      maxWidth: '400px',
      lineHeight: '1.5',
    },
  };

  return (
    <div style={styles.container}>
      <FontAwesomeIcon icon={faBook} style={styles.icon} />
      <h2 style={styles.title}>No Articles Available</h2>
      <p style={styles.description}>
        Articles for this topic are not available yet. Check back later for new content or explore other study materials.
      </p>
    </div>
  );
};

export default EmptyArticlesState; 